import { useFallbackStorageValue } from "@product/scmp-sdk";
import { useSetAtom } from "jotai";
import { useEffect } from "react";

import { sendGTMTracking } from "~/components/tracking/google-tag-manager/apis";

import { gdprAtom } from "./atoms";

export * from "./atoms";

const GDPR_KEY = "gdpr_202006";

export const useGDPRSetup = () => {
  // This key will be set by the GDPR banner
  const { value: isAcceptedGDPR } = useFallbackStorageValue(GDPR_KEY, { defaultValue: false });
  const setGDPR = useSetAtom(gdprAtom);

  useEffect(() => {
    const handleGDPREvent = (event: MessageEvent) => {
      if (event.data !== "CLOSE_GDPR") return;
      window.removeEventListener("message", handleGDPREvent);

      // In this case, the user accept ed the GDPR
      // isAccepted' will be 'true' but the 'isNextSession' will be 'false'
      setGDPR({
        isAccepted: true,
        isNextSession: false,
      });
    };

    if (!isAcceptedGDPR) {
      window.addEventListener("message", handleGDPREvent, false);
      return;
    }

    sendGTMTracking({ event: "optimize.acceptedGDPR" });
    sendGTMTracking({
      event: "GDPROptions",
      overlays: {
        isAcceptedGDPR: true,
      },
    });

    // In this case, the GDPR is already accepted by user
    // The GDPR banner has already set the local storage value
    setGDPR({
      isAccepted: true,
      isNextSession: true,
    });

    // Clean up the listener
    return () => {
      window.removeEventListener("message", handleGDPREvent);
    };
  }, [isAcceptedGDPR, setGDPR]);
};
